import { render, staticRenderFns } from "./BarApp.vue?vue&type=template&id=6e7e5d02&scoped=true"
import script from "./BarApp.vue?vue&type=script&lang=js"
export * from "./BarApp.vue?vue&type=script&lang=js"
import style0 from "./BarApp.vue?vue&type=style&index=0&id=6e7e5d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7e5d02",
  null
  
)

export default component.exports